import React from 'react';
import classnames from 'classnames';

import styles from './styles.module.scss';

const typeToTag = {
  span: 'span',
  p: 'p',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  logo: 'span',
}

type Props = {
  type?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'logo';
  small?: boolean;
  muted?: boolean;
  italic?: boolean
  className?: string;
  children: React.ReactNode;
  [x: string]: any;
};

const Text: React.FC<Props> = (props) => {
  const { type = 'span', small, muted, italic, className, children, ...rest } = props;
  const Tag: any = typeToTag[type];
  
  const classNames = classnames(styles['base'], styles[type], {
    [styles['small']]: small,
    [styles['muted']]: muted,
    [styles['italic']]: italic,
  }, className);
  
  return (
    <Tag className={classNames} {...rest}>{children}</Tag>
  );
};

export default Text;
